import { ChannelsHealthWidget } from '../../components/analytics/ChannelsHealthWidget';
import { FunnelWidget } from '../../components/analytics/FunnelWidget';
import { SlaWidget } from '../../components/analytics/SlaWidget';

export function AnalyticsPage() {
  return (
    <div className="flex h-full flex-col">
      <div className="border-b border-border px-4 py-3">
        <h1 className="text-lg font-semibold">Аналитика</h1>
      </div>
      <div className="flex-1 space-y-4 overflow-y-auto p-4">
        <FunnelWidget />
        <SlaWidget />
        <ChannelsHealthWidget />
      </div>
    </div>
  );
}
